<template>
    <div id="topHeader" v-if="!isApp">
        <div class="fixedTop">
            <div class="softHead" v-if="showDownload&&showDownloadCloseBtn!=true">
                <template  v-if="isAndroidShow&&isWx">
                 <wx-open-launch-app
                    id="launch-btn"
                    style="width: 100%; display: block"
                    extinfo=""
                    appid="wx7f6c9c7fe8734e8f"
                    >
                    <script type="text/wxtag-template">
                        <style>
                                .softHead {
                                height: 2.4rem;background-color: #ffffff;border-bottom: .05rem solid #e7e7e7;position: relative;z-index: 2;
                            }

                            .logoImg {
                                height: 2rem;
                                position: absolute;
                                left:1rem;
                                top: 0.5rem;
                            }

                            .openApp {
                                position: relative;
                                display: block;
                                height:3.2rem;
                                background-color: #E5F5EF;
                                padding-left: 2.7rem;
                            }

                            .openBtn {
                                position: absolute;
                                width: 5rem;
                                height: 2rem;
                                background-color: #009B5F;
                                border-radius: 1.35rem;
                                color: #ffffff;
                                text-align: center;
                                line-height: 2rem;
                                font-size: 0.7rem;
                                right: 1rem;
                                top: 50%;
                                margin-top: -1rem;
                            }
                        </style>
                        <div class="openApp goToAppBtn">
                                        <img class="logoImg" src="https://img12.artimg.net/public/cms-cloud/png/202410/d82f8c60537c2655626e9c4cbb0fbc2e.png" alt="">
                                       
                                        <span class="openBtn">打开APP</span>
                                    </div>
                    </script>
                    </wx-open-launch-app>
                </template>
                <template  v-else>
                    <!-- <span class="del" @click="closeDownload"></span> -->
                    <div class="openApp goToAppBtn" :data-url="appLink" :data-spread="spreadID" @click="gotoAppDownload">
                        <!-- <h3 class="appTitle">雅昌拍卖图录</h3> -->
                        <!-- <p class="appDes">汇聚全球拍卖数据 专业拍卖必备工具</p> -->
                        <span class="openBtn">打开APP</span>
                    </div>
                </template>
            </div>
            <div class="headerTop" id="headerTop" v-if="ifShowHeader">
                <div class="top-left">
                    <div class="top-back" v-if="!isWx" @click="gotoBack"></div>
                    <div class="top-nav" @click="navClick" v-if="isShowNav"></div>
                    <div class="top-nav" style="background-image: none" v-if="!isShowNav"></div>
                </div>
                <div class="top-content" :class="{'noLogin':!showLogin}">{{ wapTitle }}</div>
                <div class="top-right" v-if="showLogin">
                    <div class="top-so" @click="goso"></div>
                    <div class="top-person">
                        <span class="beforeLogin" @click="gotoLogin" v-if="uid <=0">登录</span>
                        <span v-if="uid > 0" @click="openPerson"><img :src="headerImg" alt=""></span>
                    </div>
                </div>
                <div class="top-right" v-if="showBtn">
                    <div class="right-text" @click="goRight">
                    送拍记录
                    </div>
                   
                </div>
                <div class="personNav" v-if="showLogin" :class="{'personNavOpen':personShow}">
                    <dl class="personHeader">
                        <dt><img :src="headerImg" alt=""></dt>
                        <dd>{{personName}}</dd>
                    </dl>
                    <ul>
                        <li><a href="//member.artron.net">用户中心</a></li>
                        <li><a href="//passport.artron.net/my/chgpasswd/">修改密码</a></li>
                        <li><a href="javascript:;" @click="exit" class="exit">退出登录</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="navList" v-if="showNav" :class="{'navShow':navShow}">
            <div class="navBg" @click="backHome"></div>
            <div class="navBox">
                <div class="navTop"><span class="back" @click="backHome"></span></div>
                <div class="navListBox">
                    <ul>
                        <li>
                            <div class="noArrow"><a href="https://m.artron.net">雅昌艺术网</a></div>
                        </li>
                        <li>
                            <div class="navFirst" @click="clickOpen" :class="{'navFirstCurr':secNavSHow}">雅昌拍卖</div>
                            <div class="navSec" :class="{'navSecShow':secNavSHow}">
                                <router-link :to="{path:'/'+waterLink}">拍卖首页</router-link>
                                <router-link :to="{path:'/preview'+waterLink}" :class="{'curr':$route.name == 'preview'}">拍卖数据</router-link>
                                <a :href="'https://m-auction.artron.net/live/'+waterLink">拍卖直播</a>
                                <a href="http://zxp.artron.net">得藏</a>
                                <!-- <a href="javascript:;" @click="gotoLogin" v-if="uid <=0">我的</a>
                                <a href="javascript:;" v-else @click="openPerson">我的</a> -->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="!noPosHeader" class="posHeader" :style="{height:docH+'px'}"></div>
    </div>
</template>

<script>
import {isWeixin} from "@/api/auction/isWeixin";
import {gotoLogin} from "@/assets/js/scData";

export default {
    name: "hearder-top",
    props:['wapTitle','appLink','spreadID','showNav','isShowNav','showLogin','isDetail','isApp','showBtn','showDownloadCloseBtn','extinfo','noPosHeader'],
    data(){
        return{
            waterLink:this.$route.query.from ? '?from='+this.$route.query.from : '',
            navShow:false,
            secNavSHow:false,
            docH:0,
            headerH:0,
            showDownload:true,
            isAndroidShow: false,
            uid:0,
            personName:'',
            headerImg:'',
            personShow:false,
            ifShowHeader:true,
            launchFlag:false,
            isWx:false,
            link:''
        }
    },
    created() {
    },
    watch: {
        docH(val) {
            this.$emit('heightChange', val)
        }
    },
    mounted() {
        let that = this;
        var isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
        var isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
        this.isAndroidShow = navigator.userAgent.match("Android");
        if(this.$route.name == 'preview'){
            this.secNavSHow = true
        }
        if(isWeixin()){
            this.isWx = true
        }
        if(isWeixin() && this.isDetail && this.showNav){
            this.ifShowHeader = false
            this.docH = document.querySelector('.softHead').clientHeight
        }else if(!this.showNav){
            if(isTuluApp || isToutiaoApp){
                this.showDownload = false;
                this.docH = 0
            }else{
                this.docH = document.querySelector('.softHead').clientHeight
            }
            this.ifShowHeader = false

        }else{
            if(isTuluApp || isToutiaoApp){
                this.showDownload = false;
                document.querySelector('.top-back').style.display = 'none'
                this.docH = document.querySelector('#headerTop').clientHeight
            }else{
                this.docH = document.querySelector('.fixedTop').clientHeight
            }
            this.headerH = document.querySelector('#headerTop') ? document.querySelector('#headerTop').clientHeight : 0
        }
        this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
        this.headerImg  = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0?'https://img12'+ '.artimg.net/passport/avatar/' +this.uid .substring(0, 3) + '/' + this.uid .substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t='+new Date().getTime() : '';
        this.personName = this.getCookie('_at_pt_1_') ? decodeURI(this.getCookie('_at_pt_1_')) : '';
        this.isWx = isWeixin() ? true : false
        if(this.isAndroidShow&&this.isWx){
            setTimeout(() => {
                var btn = document.getElementById("launch-btn");
                btn.addEventListener("ready", (e) => {
                    // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                    console.log("-----------------ready");
                   
                    e.target.setAttribute('extinfo', that.extinfo)
                    that.launchFlag=true;
                });
                btn.addEventListener("launch", (e) => {
                    // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                    console.log("-----------------success");
                });
                btn.addEventListener("error", (e) => {
                    // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                    console.log("---------------fail", e.detail);
                   
                    window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=app.Artronauction&fromcase=70051&g_f=1182517&scenevia=XQYFX";
                });
            }, 100);
            setTimeout(() => {
                if(that.launchFlag==false){
                    that.isAndroidShow=false;
                }
            }, 1000);
           
        }

    },
    methods:{
        gotoAppDownload(){
            this.$emit('gotoApp')
        },
        goRight(){
            this.$emit('goRight')
        },
        navClick(){
            this.navShow = true;
            document.querySelector('.page').classList.add('overhide')
        },
        
        gotoLogin:function (){
            gotoLogin()
        },
        exit:function (){
            window.location.href = '//passport.artron.net/memCenter/logout?redirect='+encodeURIComponent(window.location.origin)
        },
        goso() {
            this.$router.push({ path: "/search/all/"+this.waterLink });
        },
        openPerson(){
            this.personShow = !this.personShow;
        },
        getCookie:function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if(document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            }else {
                return null;
            }
        },
        formatZero:function (num) {
            if(num.length < 9){
                num = (Array(10-num.length).join(0) + num);
                return num;
            }else{
                return num;
            }
        },
        backHome(){
            this.navShow = false;
            document.querySelector('.page').classList.remove('overhide')
        },
        clickOpen(){
            this.secNavSHow = !this.secNavSHow;
        },
        gotoBack(){
            if (document && document.referrer) {
                window.location.href=document.referrer;
            } else if(window.history.state) {
                this.$router.back()
            }else{
                this.$router.push({ path: "/" });
            }
        },
        closeDownload(){
            this.showDownload = false
            this.docH = this.headerH
        },
    }
}
</script>

<style lang="scss">
@import url("../../../assets/css/reset.css");
#topHeader{z-index: 334!important;}
.fixedTop{z-index: 334!important;}
.headerTop{height:2.2rem;display:flex;justify-content: space-between;background-color: #fff;box-shadow:0rem 0.15rem 0.2rem 0rem rgba(0,0,0,.1);position: relative;
    .top-left{width:4.4rem;display:flex;}
    .top-back{width:2.5rem;height:2.2rem;background:url("../../../assets/img/icon_nav_back.png") no-repeat center;background-size: 1rem auto;display:inline-block;}
    .top-content{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;overflow: hidden;line-height: 2.2rem;font-size: .9rem;color:#27282d;position: absolute;left:6rem;right:6rem;text-align: center;}
    .noLogin{left:2.2em;right:2.2rem;}
    .top-right{
        width:6rem;
        display:flex;
        align-items: center;
        justify-content:flex-end;
    }
    .right-text{
        color: #009B5F;
        margin-right: 15px;
    }
    .top-so {
        width: 2.2rem;
        height: 2.2rem;
        background-image: url(../../../assets/img/icon_nav_search.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 1rem auto;
        position: relative;
        z-index: 1;
        float:right;
    }
    .top-nav{display:inline-block;width:2.5rem;height:2.2rem;background:url('../../../assets/img/icon_nav_menu.png') no-repeat center;background-size: 1rem auto;}
    .top-person{float:right;display:flex;height:2.2rem;align-items: inherit;padding-right: .5rem;
        .beforeLogin{width:3.5rem;line-height: 1.5rem;border:.05rem solid #BFBFBF;border-radius: .2rem;text-align: center;font-size: .6rem;color:#595959;}
        img{width:1.5rem;height:1.5rem;object-fit: cover;border-radius: 50%;overflow: hidden}
    }
    .personNav{position: absolute;width: 9rem;z-index: -1!important;
        background: #FFFFFF;
        box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
        opacity: 0;
        border-radius: 0rem 0rem 0.2rem 0.2rem;right:.75rem;top:100%;
        transition: .2s all ease-in-out;
        transform: translateY(-100%);
        .personHeader{border-bottom: .05rem solid #F2F2F2;padding:.75rem;text-align: center;
            img{width:2rem;height:2rem;border-radius: 50%;object-fit: cover;overflow: hidden;}
            dd{margin-top: .25rem;line-height: 1.2rem;color:#000;font-size: .8rem;font-weight: bold;}
        }
        ul{
            padding-bottom: .75rem;padding-top: .75rem;
            li{margin-bottom: 1rem;}
            li:last-child{margin-bottom: 0;}
            a{display:block;text-align: center;line-height: 1.1rem;font-size: .7rem;color:#595959;}
            .exit{display:block;width:7rem;line-height: 1.5rem;text-align: center;border-radius: .2rem;border:.05rem solid #BFBFBF;font-size: .6rem;margin:0 auto;}
        }
    }
    .personNavOpen{transform: translateY(0);opacity: 1;z-index: 1;}
}
.navList{position: fixed;height:100%;width:100%;z-index: -100;transform: scale(0)}
.navList .navBg{width:100%;height:100%;transition: .2s transform ease-in-out;background-color: rgba(0,0,0,0);position: absolute;}
.navBox{width:14rem;transform: translateX(-100%);background-color: #fff;height:100%;transition: .2s transform ease-in-out;}
.navList.navShow{z-index: 335;transform: scale(1)}
.navList.navShow .navBg{background-color: rgba(0,0,0,.55);}
.navList.navShow .navBox{transform: translateX(0)}
.navTop{height:2.6rem;border-bottom: .05rem solid #F2F2F2;}
.navTop .back{display:inline-block;width:2.5rem;height:2.5rem;background:url("../../../assets/img/icon_nav_close.png") no-repeat center;background-size: .9rem auto;}
.navListBox{
    .navFirst,.noArrow{line-height: 2.6rem;padding:0 .75rem;color: #262626;font-size: .8rem;font-weight: bold;position: relative;}
    .navFirst:after{display:block;width:.8rem;height:.8rem;background: url("../../../assets/img/icon_list_more_grey_light@3x.png") no-repeat;background-size: contain;position: absolute;right:.75rem;content: '';top:.9rem;transition: .3s transform ease-in-out;}
    .navSec{max-height:0;transition:max-height 0.3s ease-in-out;overflow: hidden;
        a{display:block;line-height: 2.7rem;padding:0 1.5rem;font-size: .7rem;color: #595959;}
        //.router-link-active{color:#329D15;background-color: #EAF5E7;}
    }
    .navFirstCurr:after{transform: rotate(-180deg)}
    .navSec{
        a.curr{background-color:#EAF5E7;color:#329D15}
    }
    .navSec.navSecShow{max-height:500px;}

}
</style>